<template>
    <v-content class="tour-ai-dashboard">
    <v-container grid-list-xl style="padding-block: 10px; margin-top: 30px">
       <v-card dark class="card-animate-2">
          <v-app-bar
            color="rgba(12, 22, 27, 0.9)"
            max-height="150"
            height="125"
            elevation="3"
            dense
            dar12
          >
            <v-toolbar-title>
              <v-avatar size="40">
                                <img src="@/assets/DashIcon.png">
                        </v-avatar>
              Tour Prediction
            </v-toolbar-title>
        
          <v-spacer></v-spacer>

          <v-chip class="ml-2" color="#00ffe5" text-color="black">Pollstar</v-chip>
          <v-chip class="ml-2" color="#00ffe5" text-color="black">Ticketmaster</v-chip>
          <v-chip class="ml-2" color="#00ffe5" text-color="black">Spotify</v-chip>
          <v-chip class="ml-2" color="#00ffe5" text-color="black">OpenAI</v-chip>
        </v-app-bar>
        </v-card>  
      <!-- <v-card dark class="card-animate-2">
          <v-app-bar
            color="rgba(12, 22, 27, 0.9)"
            max-height="250"
            height="250"
            elevation="3"
            dense
          >
          <v-col cols="12" class="text-center pb-0">
            <v-container grid-list-xl>
              <v-flex xs4 sm4 md4 lg12>

          </v-flex>
        </v-container> 
          <p class="futuristic-glow">Artist Tour Predictor</p>
        
                    <br />
          <v-chip
            class="ml-2"
            color="#00ffe5"
            text-color="black"
            style="font-size: 15px; font-weight: bold; padding: 10px 20px;"
            >Pollstar</v-chip>
          <v-chip
            class="ml-2"
            color="#00ffe5"
            text-color="black"
            style="font-size: 15px; font-weight: bold; padding: 10px 20px;"
            >Ticketmaster</v-chip>
          <v-chip
            class="ml-2"
            color="#00ffe5"
            text-color="black"
            style="font-size: 15px; font-weight: bold; padding: 10px 20px;"
            >Spotify</v-chip>
          <v-chip
            class="ml-2"
            color="#00ffe5"
            text-color="black"
            style="font-size: 15px; font-weight: bold; padding: 10px 20px;"
            >Open AI</v-chip>
          

          <br />
        </v-col>
          </v-app-bar>
        </v-card> -->
        </v-container>
<br />
<br />
    <v-container class="card-animate-2">

      <v-row>
  <v-col cols="12" class="text-center">
    <div class="artist-count-glow">
      <!-- <v-icon large color="#00ffe5" class="mr-2">mdi-account-music</v-icon> -->
      <span class="artist-count-label">Total Artists:</span>
      <span class="artist-count-number">{{ artistPresets.length }}</span>
    </div>
  </v-col>
</v-row>

      <v-row align="center" class="mb-3">
        <v-col cols="12" md="3" class="text-center">
          <v-select
  v-model="selectedGenre"
  :items="Object.keys(artistGenres)"
  label="Select Genre"
  outlined
  dense
  dark
  class="genre-select"
/>


        </v-col>
        <v-col cols="12" md="3" class="text-center">


<!-- <v-autocomplete
  v-model="selectedArtist"
  :items="artistGenres[selectedGenre]"
  label="Select or Search Artist"
  dense
  outlined
  clearable
  append-icon="mdi-magnify"
  hide-selected
  :loading="aiLoading"
  dark
/> -->
<!-- <v-autocomplete
  v-model="selectedArtist"
  :items="artistGenres[selectedGenre]"
  label="Select or Search Artist"
  dense
  outlined
  clearable
  append-icon="mdi-magnify"
  hide-selected
  :loading="aiLoading"
  dark
  @change="onArtistSelected"
> -->
  <!-- <template v-slot:item="data">
    <v-list-item>
      <v-list-item-content>
        <v-chip
          :color="genreColor(selectedGenre)"
          text-color="white"
          small
          class="mr-2"
        >
          {{ selectedGenre }}
        </v-chip>
        <span>{{ cleanArtistName(data.item) }}</span>
      </v-list-item-content>
    </v-list-item>
  </template> -->
  <v-autocomplete
  v-model="selectedArtist"
  :items="artistGenres[selectedGenre]"
  label="Select or Search Artist"
  dense
  outlined
  clearable
  append-icon="mdi-magnify"
  hide-selected
  :loading="aiLoading"
  dark
>
</v-autocomplete>


        </v-col>
        <v-col cols="12" md="3">
          <v-text-field
            v-model="manualArtist"
            label="Or type any artist name"
            dense
            outlined
            @keydown.enter="startResearch"
            dark
          />
        </v-col>

        <v-col cols="12" md="3" class="text-center">
  <v-btn
    block
    large
    color="accent"
    class="go-button pulse-animation"
    :loading="aiLoading"
    @click="startResearch"
  >
    GO <v-icon right>mdi-rocket-launch</v-icon>
  </v-btn>
</v-col>

      </v-row>
      <v-container ref="resultsSection">
      <v-row v-if="forecast">
        <v-col cols="12" md="12">
          <v-card dark color="#1a2330" class="mb-3">
            <v-card-title>🎤 Artist: {{ forecast.artist }}</v-card-title>
            <v-card-text class="text-center">
              <img v-if="artistImg" :src="artistImg" alt="Artist Image" class="artist-image" />
            </v-card-text>
            <v-row class="mb-3">
        <v-col cols="12" class="text-center">
          <p v-if="aiLoading" class="steps-glow">Loading AI research...</p>
        
        </v-col>
      </v-row>
      <br />
      <br />

      <v-row>
        <v-col cols="12" style="margin-block:-30px; padding-block: 20px; border-radius: 25px;">
          <v-stepper v-model="currentStep" class="ai-stepper-glow" non-linear alt-labels>
            <v-stepper-header>
              <v-stepper-step
                v-for="s in stepDescriptors"
                :key="s.index"
                :complete="currentStep > s.index"
                :step="s.index"
                editable
                @click="currentStep = s.index"
                class="stepper-step-glow"
              >
                {{ s.title }}
              </v-stepper-step>
            </v-stepper-header>

            <v-stepper-items>
              <v-stepper-content
                v-for="s in stepDescriptors"
                :key="s.index"
                :step="s.index"
                class="py-2"
              >
                <div v-if="aiLog[s.index]" class="fadein-step">
                  <div v-html="aiLog[s.index]" class="step-contents" />
                </div>

                <v-btn
                  v-if="s.index < stepDescriptors.length"
                  color="blue-grey darken-2"
                  class="ma-2"
                  @click="nextStep"
                  small
                >
                  Next Step
                </v-btn>
              </v-stepper-content>
            </v-stepper-items>
          </v-stepper>
        </v-col>
      </v-row>
          </v-card>
          <br />
          <br />
  <v-menu bottom left>
  <template v-slot:activator="{on}">
    <v-btn icon v-on="on"><v-icon>mdi-content-save</v-icon></v-btn>
  </template>
  <v-list dense>
    <v-list-item @click="saveForecastLocally"><v-list-item-title>Save / Update</v-list-item-title></v-list-item>
    <v-list-item @click="deleteForecast(selectedArtist)"><v-list-item-title>Delete saved</v-list-item-title></v-list-item>
  </v-list>
</v-menu>
</v-col>
<br />
<br />
<br />   
<br />

<v-divider class="my-4" color="#31f0ff" />

        <v-col cols="12" md="12">
  <br />

  <v-card dark color="#131324" class="mb-3 futuristic-card">
    <v-card-title>📈 Tour Frequency</v-card-title>
    <v-card-text style="height:230px">
      <!-- <tour-linechart
        :chartData="forecast.frequencyData"
        @hoverYearIndex="hoveredYearIndex = $event"
      /> -->
      <tour-linechart
  :chartData="forecast.frequencyData"
  @hoverYearIndex="handleHoverYear"
/>

    </v-card-text>
  </v-card>
  <br />
  <v-expand-transition>
  <v-card
    v-if="popupActive && selectedYear && selectedEvents.length"
    class="mt-2 mb-4 px-4 py-2 futuristic-card-2"
    color="#1c2f36"
    dark
    style="height: 350px; border-left: 3px solid #00ffe5; position: relative;"
  >
    <v-card-title class="headline">
      🎟️ Events in {{ selectedYear }}
    </v-card-title>
    <v-card-text>
      <v-list dense>
        <v-list-item
          v-for="(event, i) in selectedEvents"
          :key="i"
        >
          <v-list-item-content>
            <v-list-item-title style="padding-bottom: 20px;" class="headline">
              📍 {{ event.city }} — {{ event.venue }}
            </v-list-item-title>
            <v-list-item-subtitle>{{ new Date(event.date).toLocaleDateString() }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-card-text>
    <v-card-actions class="justify-end">
      <v-btn small text color="red" @click="popupActive = false">
        Close
      </v-btn>
    </v-card-actions>
  </v-card>
</v-expand-transition>

</v-col>


          

<v-col cols="12" md="12">
  <v-btn
    block
    color="cyan darken-2"
    class="toggle-btn mb-2"
    @click="showHeatmap = !showHeatmap"
    dark
  >
    🌍 Toggle Tour Heatmap
    <v-icon right>{{ showHeatmap ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
  </v-btn>
<br />
  <v-expand-transition>
    <v-card
      v-if="showHeatmap"
      dark
      color="#1a2330"
      class="futuristic-card-accordion"
    >
      <v-card-title>Artist Tour Route</v-card-title>
      <v-card-text style="height:370px">
        <!-- <v-select
  v-model="selectedYear"
  :items="availableYears"
  label="Select Year"
  outlined
  dense
  dark
  class="my-4"
/> -->

<v-select
  v-model="selectedYear"
  :items="availableYears"
  label="Select Year"
  outlined
  dense
  dark
  class="my-4"
  @change="filterByYear"
/>

<v-col cols="12" md="12">
            <v-card dark color="#1a2330" class="futuristic-card mb-3">
              <v-card-title>🌎 Tour Map</v-card-title>
              <v-card-text>
                <div id="tour-map" style="height: 400px; width: 100%; border-radius: 12px;" />
              </v-card-text>
            </v-card>
          </v-col>
          <!-- <div ref="mapContainer" class="tour-worldmap"></div>
          <tour-worldmap
  :locations="forecast.heatmapData"
  :activeYear="selectedYear"
/> -->


  <!-- <v-btn key="1" color="blue-grey darken-2" class="ma-2" @click="showHeatmap = true" small> Render Map</v-btn> -->
          <v-row class="mt-2">
            <v-col cols="12" class="text-center">
              <p v-if="aiLoading" class="steps-glow">Loading AI research...</p>
            </v-col>
          </v-row>


      </v-card-text>
  

      <v-card-actions style="padding: 0px; margin-top: 200px; margin-right: -150px">
        <v-btn text @click="showHeatmap = false">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-expand-transition>
</v-col>

      </v-row>
      </v-container>
      
<br />

<v-row v-if="forecast">
  <v-col cols="12" md="12">
    <v-card color="#162c29" class="mb-3 futuristic-card-glow" dark>
      <v-card-title class="glow-title">📊 Forecast Summary</v-card-title>
      <v-card-text>
        <div class="glow-block">
          <label>🧠 Pattern Summary:</label>
          <p class="summary-glow">{{ forecast.pattern_summary }}</p>
        </div>
  
      </v-card-text>
    </v-card>
  </v-col>

  <v-col cols="12" md="6">
    <v-card color="#162c29" class="mb-3 futuristic-card-glow" dark>

      <v-card-text>
        <div class="glow-block">
          <label>📈 Event Coverage:</label>
          <p class="summary-glow">{{ forecast.stats.coverage }}</p>
          <label>📡 Data Sources:</label>
          <p class="summary-glow">{{ forecast.stats.sources }}</p>
        </div>
  
      </v-card-text>
    </v-card>
  </v-col>
  <v-col cols="12" md="6">
    <v-card color="#162c29" class="mb-3 futuristic-card-glow" dark>

      <v-card-text>

        <div v-if="forecast.confidence_intervals" class="glow-block">
          <label>🕒 Forecast Window:</label>
          <p style="font-size: 26px; color: #00ffe5;" class="summary-glow">
            {{ forecast.confidence_intervals.start_date }}–{{ forecast.confidence_intervals.end_date }}
            {{ forecast.confidence_intervals.duration_months[0] }}–{{ forecast.confidence_intervals.duration_months[1] }} months
          </p>
          <label>📍 Timeline Uncertainty:</label>
          <p style="font-size: 26px; color: #00ffe5;" class="summary-glow">
            {{ forecast.confidence_intervals.start_date }}–{{ forecast.confidence_intervals.end_date }}±{{ forecast.confidence_intervals.start_uncertainty }}</p>
        </div>
      </v-card-text>
    </v-card>
  </v-col>

  <v-col cols="12" md="12">
    <v-card dark color="#142031" class="mb-3 futuristic-card-glow">
      <v-card-title class="glow-title">🔮 Next Predicted Tour Windows</v-card-title>
      <v-card-text>
        <v-simple-table class="forecast-table">
          <thead>
            <tr>
              <th>Period</th>
              <th>Probability</th>
              <th>Regions</th>
            </tr>
          </thead>
          <tbody style="padding-block: 20px;">
            <tr v-for="w in forecast.forecast_windows" :key="w.period">
              <td class="forecast-chip">{{ w.period }}</td>
              <td class="forecast-chip animated-chip">{{ Math.round(100 * w.probability) }}%</td>
              <td>
                <v-chip
                  v-for="region in w.likely_regions"
                  :key="region"
                  color="cyan darken-2"
                  text-color="white"
                  class="forecast-chip animated-chip"
                  small
                >
                  {{ region }}
                </v-chip>
              </td>
            </tr>
          </tbody>
        </v-simple-table>
      </v-card-text>
    </v-card>
  </v-col>
</v-row>

      <br />
      <!-- <v-row v-if="forecast?.businessAcquisitionReport">
  <v-col cols="12">
    <v-card class="futuristic-card-glow" dark color="#0f1e2e">
      <v-card-title class="glow-title">🚀 Business Acquisition Report (PRG)</v-card-title>
      <v-card-text>

        <div class="glow-block">
          <br />
          <label>🎯 Recommended Action Steps:</label>
          <br />
          <v-chip class="summary-glow" style="font-size: 36px; color: #00e7ff; background-color: #000; height: fit-content; width: fit-content; margin: 5px 5px 5px 5px; padding: 15px 15px 15px 15px;">
            {{ forecast.businessAcquisitionReport.recommended_action_steps.length }} steps
          </v-chip>
          <br />
          <br />
          <ul style="padding-left: 50px; padding-bottom: 20px;">
            <li v-for="(step, index) in forecast.businessAcquisitionReport.recommended_action_steps" :key="index" style="padding-bottom: 20px;">
              <v-chip class="forecast-chip" style="font-size: 20px; color: #00ffe5;">
                {{ step }}
              </v-chip>
            </li>
          </ul>
        </div>

        <div class="glow-block mt-6">
          <br />
          <label>🏟️ Priority Venues:</label>
          <br />
          <v-list dense two-line>
            <v-list-item
              v-for="(venue, index) in forecast.businessAcquisitionReport.priorityVenues"
              :key="index"
              @click="flyToLocation(venue.latlng)"
              class="venue-item-glow"
            >
              <v-list-item-content>
                <v-list-item-title class="white--text">
                  📍 {{ venue.venue }}, {{ venue.city }}
                </v-list-item-title>
                <v-list-item-subtitle class="cyan--text">
                  Services: {{ venue.recommended_services.join(", ") }} | Est. Capacity: {{ venue.estimated_capacity }}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </div>

        <div class="glow-block mt-6">
          <br />
          <label>📈 PRG Opportunity Score:</label>
          <br />
          <p class="summary-glow" style="font-weight: bold; letter-spacing: 1.55px; padding: 18px 16px 18px 16px; background: linear-gradient(to right, #1c2f36, #101720); margin: 4px 4px 4px 0; border-radius: 8px; font-size: 2.6rem; text-align: center;">
            {{ Math.round(forecast.businessAcquisitionReport.prg_opportunity_score * 100) }}%
          </p>
        </div>

      </v-card-text>
    </v-card>
  </v-col>
</v-row> -->
<v-row v-if="forecast?.businessAcquisitionReport">
  <v-col cols="12" md="12">
    <v-card color="#162c29" class="mb-3 futuristic-card-glow" dark>
      <v-card-title class="glow-title">🏢 Business Acquisition Report for PRG</v-card-title>
      <v-card-text>
        <v-row v-if="forecast?.artistContacts?.length">
  <v-col cols="12" md="12">
    <v-card color="#162c29" class="mb-3 futuristic-card-glow" dark>
      <v-card-title class="glow-title">🎤 Artist Contacts</v-card-title>
      <v-card-text>

        <v-row dense>
          <v-col
            v-for="(contact, index) in forecast.artistContacts"
            :key="index"
            cols="12"
            sm="6"
            md="4"
          >
            <v-card class="futuristic-contact-card" color="#1a2330" dark>
              <v-card-title class="headline" style="font-size: 20px; color: #00ffe5;">
                {{ contact.name }}
              </v-card-title>

              <v-card-subtitle class="mb-2" style="color: #8eeeff;">
                <v-chip
                  small
                  :color="roleColor(contact.role)"
                  text-color="white"
                  class="glow-chip"
                >
                  {{ contact.role }}
                </v-chip>
              </v-card-subtitle>

              <v-card-text style="font-size: 16px;">
                📧 <span style="color: #5ffffe;">{{ contact.email }}</span><br/>
                📞 <span style="color: #5ffffe;">{{ contact.phone }}</span>
              </v-card-text>
              
              <v-card-actions>
                <v-spacer></v-spacer>
                <!-- <v-btn
                  v-if="contact.phone"
                  small
                  color="cyan darken-2"
                  icon
                  :href="`tel:${contact.phone}`"
                  target="_blank"
                >
                  <v-icon>mdi-phone</v-icon>
                </v-btn>

                <v-btn
                  v-if="contact.email"
                  small
                  color="blue lighten-2"
                  icon
                  :href="`mailto:${contact.email}`"
                  target="_blank"
                >
                  <v-icon>mdi-email</v-icon>
                </v-btn> -->

                <v-btn
  v-if="contact.phone"
  small
  color="cyan darken-2"
  icon
  @click="generateCallScript(contact)"
>
  <v-icon>mdi-phone</v-icon>
</v-btn>

<v-btn
  v-if="contact.email"
  small
  color="blue lighten-2"
  icon
  @click="generateEmailPitch(contact)"
>
  <v-icon>mdi-email</v-icon>
</v-btn>

              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>

      </v-card-text>
    </v-card>
  </v-col>
</v-row>
<!-- Popup for Email Preview -->
<v-dialog v-model="emailDialog" max-width="1000px">
  <v-card dark color="#1a2330" class="futuristic-card-glow">
    <v-card-title class="headline">📧 Email Preview</v-card-title>
    <v-card-text>
      <pre style="white-space: pre-wrap; color: #000; font-size: 20px; padding-block: 40px 40px; ">{{ generatedEmail }}</pre>
    </v-card-text>
    <v-card-actions>
      <v-spacer />
      <v-btn color="cyan" text @click="sendGeneratedEmail">Send Email</v-btn>
      <v-btn color="grey" text @click="emailDialog = false">Cancel</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>


<!-- Popup for Call Script -->
<v-dialog v-model="callDialog" max-width="1200px">
  <v-card dark color="#1a2330" class="futuristic-card-glow">
    <v-card-title dark class="headline">📞 Call Script</v-card-title>
    <v-card-text>
      <pre style="white-space: pre-wrap; color: #000; font-size: 20px; padding-block: 40px 40px; ">{{ generatedCallScript }}</pre>
    </v-card-text>
    <v-card-actions>
      <v-spacer />
      <v-btn color="cyan" text @click="callDialog = false">Close</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
<!-- <v-dialog
  v-model="researchOverlayOpen"
  persistent
  max-width="100%"
  :style="{ zIndex: 1000 }"
  transition="scale-transition"
  @input="onResearchOverlayToggle"
>
  <template v-slot:activator="{ on, attrs }">
    <v-btn
      v-bind="attrs"
      v-on="on"
      color="cyan darken-2"
      class="research-button"
      :loading="aiLoading"
    >
      Research
    </v-btn>
  </template>

  <v-card dark color="#162c29" class="futuristic-card-glow text-center">
    <v-card-title class="glow-title">🚀 Research Progress</v-card-title>

    <v-card-text>

  
      <div v-if="artistImg" class="artist-scan-container">
        <v-img
          :src="artistImg"
          class="artist-scan-image"
          height="300px"
          width="100%"
          contain
        />
        <div class="scan-line"></div>
      </div>

    
      <v-stepper v-model="currentStep" class="ai-stepper-glow mt-6" non-linear alt-labels>
        <v-stepper-header>
          <v-stepper-step
            v-for="s in stepDescriptors"
            :key="s.index"
            :complete="currentStep > s.index"
            :step="s.index"
            editable
            @click="currentStep = s.index"
            class="stepper-step-glow"
          >
            {{ s.title }}
          </v-stepper-step>
        </v-stepper-header>
      </v-stepper>


      <v-list dense class="mt-4">
        <v-list-item
          v-for="(step, idx) in researchSteps"
          :key="idx"
        >
          <v-list-item-content>
            <v-list-item-title :class="step.status">
              {{ step.label }}
              <v-icon v-if="step.status === 'done'" color="green">mdi-check-circle</v-icon>
              <v-icon v-else-if="step.status === 'in progress'" color="cyan">mdi-timer-sand</v-icon>
              <v-icon v-else color="grey">mdi-progress-question</v-icon>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>

    </v-card-text>

    <v-card-actions>
      <v-spacer />
      <v-btn v-if="!aiLoading" color="cyan" @click="researchOverlayOpen = false">Close</v-btn>
    </v-card-actions>

  </v-card>
</v-dialog> -->

<v-dialog
  v-model="researchOverlayOpen"
  persistent
  fullscreen
  hide-overlay
  transition="dialog-bottom-transition"
  :style="{ backgroundColor: '#0d1b2a', zIndex: 9999 }"
  @input="onResearchOverlayToggle"
>
  <v-card flat color="#0d1b2a" class="futuristic-scan-card" dark>

    <v-card-title class="glow-title text-center justify-center">
      🚀 Research Progress
    </v-card-title>

    <v-card-text class="text-center">

      <!-- Artist Image with Scan Effect -->
      <div v-if="artistImg" class="artist-scan-container">
        <v-img
          :src="artistImg"
          class="artist-scan-image"
          height="400"
          contain
        />
        <div class="scan-line"></div>
      </div>

      <!-- Stepper -->
      <v-stepper v-model="currentStep" class="ai-stepper-glow mt-8" non-linear alt-labels>
        <v-stepper-header>
          <v-stepper-step
            v-for="s in stepDescriptors"
            :key="s.index"
            :complete="currentStep > s.index"
            :step="s.index"
            editable
            @click="currentStep = s.index"
            class="stepper-step-glow"
          >
            {{ s.title }}
          </v-stepper-step>
        </v-stepper-header>
      </v-stepper>

      <!-- Research Steps List -->
      <v-list dense class="mt-6">
        <v-list-item v-for="(step, idx) in researchSteps" :key="idx">
          <v-list-item-content>
            <v-list-item-title :class="step.status">
              {{ step.label }}
              <v-icon v-if="step.status === 'done'" color="green">mdi-check-circle</v-icon>
              <v-icon v-else-if="step.status === 'in progress'" color="cyan">mdi-timer-sand</v-icon>
              <v-icon v-else color="grey">mdi-progress-question</v-icon>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>

    </v-card-text>

    <v-card-actions>
      <v-spacer />
      <v-btn
        v-if="!aiLoading"
        color="cyan"
        large
        class="mt-4"
        @click="researchOverlayOpen = false"
      >
        Close
      </v-btn>
    </v-card-actions>

  </v-card>
</v-dialog>

<v-dialog
  v-model="searchPopupOpen"
  persistent
  max-width="500"
  :style="{ zIndex: 1500 }"
  transition="dialog-bottom-transition"
>
  <v-card dark color="#0e1b2b" class="ai-search-popup text-center">
    <v-card-text>
      <v-img
        src="https://media.giphy.com/media/Qr8JE9Hvi7avey8CLd/giphy.gif"
        max-height="160"
        contain
        class="ai-search-gif"
      />
      <h2 class="ai-popup-text">🤖 Researching Artist Profile...</h2>
      <p class="ai-popup-subtext">Analyzing live data, please wait...</p>
    </v-card-text>
  </v-card>
</v-dialog>


        <!-- Priority Venues -->
        <v-row v-if="forecast?.businessAcquisitionReport?.priorityVenues?.length">
  <v-col cols="12" md="12">
    <v-card color="#162c29" class="mb-3 futuristic-card-glow" dark>
      <v-card-title class="glow-title">🏟️ Priority Venues</v-card-title>
      <v-card-text>

        <v-row dense>
          <v-col
            v-for="(venue, i) in forecast.businessAcquisitionReport.priorityVenues"
            :key="i"
            cols="12"
            sm="6"
            md="4"
          >
            <v-card class="futuristic-contact-card" color="#1a2330" dark>
              <v-card-title class="headline" style="font-size: 20px; color: #00ffe5;">
                📍 {{ venue.venue }}
              </v-card-title>

              <v-card-subtitle class="mb-2" style="color: #8eeeff;">
                {{ venue.city }}, {{ venue.country }}
              </v-card-subtitle>

              <v-card-text style="font-size: 16px;">
                🏟️ Capacity: <span style="color: #5ffffe;">{{ venue.estimated_capacity }}</span><br/>
                🎛️ Services: <span style="color: #5ffffe;">{{ venue.recommended_services.join(", ") }}</span>
              </v-card-text>

              <!-- Recommended Contacts -->
              <div v-if="venue.recommended_contacts?.length" class="mt-2">
                <h4 class="summary-glow">📞 Recommended Contacts</h4>
                <v-list dense>
                  <v-list-item
                    v-for="(contact, j) in venue.recommended_contacts"
                    :key="j"
                  >
                    <v-list-item-content>
                      <v-list-item-title style="color: #8eeeff;">
                        {{ contact.name }} — {{ contact.role }}
                      </v-list-item-title>
                      <v-list-item-subtitle>
                        📧 {{ contact.email }}<br/>
                        📞 {{ contact.phone }}
                      </v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-action>
                      <v-btn
                        v-if="contact.phone"
                        small
                        color="cyan darken-2"
                        icon
                        @click="generateCallScript(contact)"
                      >
                        <v-icon>mdi-phone</v-icon>
                      </v-btn>

                      <v-btn
                        v-if="contact.email"
                        small
                        color="blue lighten-2"
                        icon
                        @click="generateEmailPitch(contact)"
                      >
                        <v-icon>mdi-email</v-icon>
                      </v-btn>
                    </v-list-item-action>
                  </v-list-item>
                </v-list>
              </div>

              <!-- Sales Approach -->
              <div v-if="venue.sales_approach" class="mt-4" style="color: #00ffe5;">
                🧠 Sales Approach:<br/>
                <span style="font-size: 15px;">{{ venue.sales_approach }}</span>
              </div>

            </v-card>
          </v-col>
        </v-row>

      </v-card-text>
    </v-card>
  </v-col>
</v-row>



        <!-- Action Steps -->
        <v-row v-if="forecast?.businessAcquisitionReport?.recommended_action_steps?.length">
  <v-col cols="12" md="12">
    <v-card color="#162c29" class="mb-3 futuristic-card-glow" dark>
      <v-card-title class="glow-title">🎯 Recommended Action Steps</v-card-title>
      <v-card-text>
        <v-row dense>
          <v-col
            v-for="(step, idx) in forecast.businessAcquisitionReport.recommended_action_steps"
            :key="idx"
            cols="12"
            sm="6"
            md="4"
          >
            <v-card class="futuristic-contact-card" color="#1a2330" dark>
              <v-card-text style="font-size: 16px; color: #5ffffe;">
                {{ step }}
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-col>
</v-row>



        <!-- Opportunity Score -->
        <v-row v-if="forecast?.businessAcquisitionReport?.prg_opportunity_score !== undefined">
  <v-col cols="12" md="12">
    <v-card color="#142031" dark class="futuristic-card-glow mb-3">
      <v-card-title class="glow-title">🚀 PRG Opportunity Score</v-card-title>
      <v-card-text class="text-center">

        <p class="summary-glow" style="font-size: 3rem; font-weight: bold;">
          {{ (forecast.businessAcquisitionReport.prg_opportunity_score * 100).toFixed(1) }}%
        </p>
        <v-progress-linear
  :value="(forecast.businessAcquisitionReport.prg_opportunity_score * 100)"
  height="20"
  rounded
  background-color="#162c29"
  :color="getOpportunityColor(forecast.businessAcquisitionReport.prg_opportunity_score)"
  class="mt-6 mb-2 futuristic-progress-glow"
>
  <strong style="color: #fff; font-size: 18px;">
    {{ getOpportunityLabel(forecast.businessAcquisitionReport.prg_opportunity_score) }}
  </strong>
</v-progress-linear>
        <v-alert 
          dense 
          text 
          type="info" 
          color="#00e7ff" 
          border="left" 
          colored-border 
          class="mt-4 futuristic-alert-glow"
          style="background: rgba(26, 35, 48, 0.8); border-left: 5px solid #00ffe5;"
        >
          <div style="font-size: 18px; color: #8eeeff;">
            The <b>PRG Opportunity Score</b> indicates the potential alignment between the artist's upcoming touring activity and PRG’s services (Audio, Lighting, Staging).
            <br /><br />
            A higher score means:
            <ul style="margin-left: 25px; font-size: 16px;">
              <li>🎟️ Strong tour frequency or large audience reach</li>
              <li>🏟️ Venues ideal for PRG's staging and production solutions</li>
              <li>🔌 Higher potential to pitch audio, lighting, and production packages</li>
              <li>📞 Actionable contacts and warm sales approaches recommended</li>
            </ul>
            <br />
            Focus on venues and timeframes with highest alignment for maximum conversion opportunity.
          </div>
        </v-alert>

      </v-card-text>
    </v-card>
  </v-col>
</v-row>

      </v-card-text>
    </v-card>
  </v-col>
</v-row>

      <br />
      <v-row v-if="forecast">
        <v-col cols="12" md="12" class="text-center futuristic-card">
          <v-alert type="info" colored-border border="left" class="model-explain">
            <b>Model drivers:</b>
            <br />
            <br />
            <ul style="list-style-type: disc; padding-left: 20px; font-size: 24px; color: #00e7ff;">
              <li v-for="d in forecast.insights" :key="d">{{ d }}</li>
            </ul>
            <br />
            <div class="mt-2"><b>Self-check:</b> {{ forecast.stats.selfcheck }}</div>
          </v-alert>
        </v-col>
      </v-row>
      <v-row v-if="errorMessage">
        <v-col cols="12">
          <v-alert type="error" prominent>{{ errorMessage }}</v-alert>
        </v-col>
      </v-row>
    
<br />
      <!-- <v-card dark color="#1a2330" style="padding: 40px 40px 40px 40px;" class="mb-3">
        <v-card-title>💾 Saved Tour Forecasts</v-card-title>
        <v-card-text class="saved-search-text">
          <p>Click to load or delete saved forecasts.</p>
        </v-card-text>
        <v-row class="saved-search-grid" dense>
  <v-col
    v-for="item in savedForecasts"
    :key="item.artist"
    cols="12"
    sm="6"
    md="4"
    lg="3"
  >
    <v-card
      class="futuristic-card saved-card"
      dark
      color="#1c2f36"
      hover
      @click="loadSaved(item.artist)"
    >
      <v-img
        :src="item.artistImg || 'https://via.placeholder.com/300x180?text=No+Image'"
        height="180"
        class="artist-thumbnail"
        gradient="to bottom, rgba(0,0,0,0.2), rgba(0,0,0,0.7)"
      />
      <v-card-title class="headline">
        {{ item.artist }}
      </v-card-title>
      <v-card-subtitle class="saved-date">
        Saved on {{ formatDate(item.savedAt) }}
      </v-card-subtitle>
      <v-card-actions>
        <v-spacer />
        <v-btn icon @click.stop="loadSaved(item.artist)">
          <v-icon color="cyan lighten-2">mdi-eye</v-icon>
        </v-btn>
        <v-btn icon @click.stop="deleteForecast(item.artist)">
          <v-icon color="red">mdi-delete</v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-col>
</v-row>

</v-card> -->

<v-card dark color="#1a2330" style="padding: 40px 40px 40px 40px; margin-top: 70px;" class="mb-3">
  <v-card-title>💾 Saved Tour Forecasts</v-card-title>
  <v-card-text class="saved-search-text">
    <p>Click to load or delete saved forecasts.</p>
  </v-card-text>

  <v-row class="saved-search-grid" dense>
    <v-col
      v-for="item in savedForecasts"
      :key="item.artist"
      cols="12"
      sm="6"
      md="4"
      lg="3"
    >
      <v-card
        class="futuristic-card saved-card"
        dark
        color="#1c2f36"
        hover
        @click="loadSaved(item.artist)"
      >
        <v-img
          :src="item.artistImg ? item.artistImg : 'https://via.placeholder.com/300x180?text=No+Image'"
          height="380"
          class="artist-thumbnail"
          gradient="to bottom, rgba(0,0,0,0.2), rgba(0,0,0,0.7)"
          contain
        />
        <v-card-title class="headline">
          {{ item.artist }}
        </v-card-title>
        <v-card-subtitle class="saved-date">
          Saved on {{ formatDate(item.savedAt) }}
        </v-card-subtitle>
        <v-card-actions>
          <v-spacer />
          <v-btn icon @click.stop="loadSaved(item.artist)">
            <v-icon color="cyan lighten-2">mdi-eye</v-icon>
          </v-btn>
          <v-btn icon @click.stop="deleteForecast(item.artist)">
            <v-icon color="red">mdi-delete</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
      <br />
    </v-col>
  </v-row>
</v-card>


<br />
<br />
    </v-container>
</v-content>
</template>


<script>
/* global google */
import { Line } from 'vue-chartjs';
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import axios from 'axios';

const TourLinechart = {
  name: 'TourLinechart',
  extends: Line,
  props: {
    chartData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return { hoverIndex: null };
  },
  watch: {
    chartData: {
      deep: true,
      handler() {
        this.render();
      }
    }
  },
  mounted() {
    this.render();
  },
  methods: {
    render() {
      if (!this.chartData?.labels) return;

      this.renderChart(this.chartData, {
        responsive: true,
        maintainAspectRatio: false,
        tooltips: {
          mode: 'index',
          intersect: false,
          backgroundColor: '#1a2330',
          titleFontColor: '#00ffe5',
          bodyFontColor: '#31f0ff',
          borderColor: '#00ffe5',
          borderWidth: 1,
          callbacks: {
            title: (tooltipItems) => tooltipItems[0].label,
            label: (tooltipItem) => `Shows: ${tooltipItem.value}`
          }
        },
        hover: {
          onHover: (e, chartElements) => {
            this.hoverIndex = chartElements.length ? chartElements[0]._index : null;
            this.$emit('hoverYearIndex', this.hoverIndex);
          }
        },
        legend: {
          labels: {
            fontFamily: "'Orbitron', monospace",
            fontColor: '#5ffffe',
            fontSize: 14
          }
        },
        scales: {
          xAxes: [{
            gridLines: { color: '#21405e' },
            ticks: { fontColor: '#37f0e1', fontSize: 12 }
          }],
          yAxes: [{
            gridLines: { color: '#23475d', zeroLineColor: '#0f238b' },
            ticks: { fontColor: '#63f9ec', fontSize: 12 }
          }]
        },
        elements: {
          line: {
            tension: 0.4, // smooth curves
            borderColor: '#00ffe5',
            borderWidth: 3
          },
          point: {
            backgroundColor: '#00ffe5',
            radius: 5,
            hoverRadius: 8,
            borderColor: '#1a2330',
            borderWidth: 2
          }
        }
      });
    }
  }
};

// const TourWorldmap = {
//   name: 'TourWorldmap',
//   props: ['locations', 'activeYear'],
//   data() {
//     return {
//       map: null,
//       markersLayer: null
//     };
//   },
//   mounted() {
//     this.map = L.map(this.$refs.mapContainer, { center: [20, 0], zoom: 2 });
//     L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
//       attribution: '&copy; OpenStreetMap contributors'
//     }).addTo(this.map);

//     this.markersLayer = L.layerGroup().addTo(this.map);
//     this.addMarkers();
//   },
//   watch: {
//     locations: {
//       handler() {
//         this.addMarkers();
//       },
//       deep: true
//     },
//     activeYear() {
//       this.addMarkers();
//     }
//   },
//   methods: {
//     addMarkers() {
//       if (!this.map || !this.markersLayer) return;
//       this.markersLayer.clearLayers();

//       const filtered = this.activeYear
//         ? this.locations.filter(loc => loc.date?.startsWith(this.activeYear))
//         : this.locations;

//       filtered.forEach(loc => {
//         if (loc.latlng && loc.latlng.length === 2) {
//           L.circleMarker(loc.latlng, {
//             radius: 8,
//             fillColor: "#00ffe5",
//             color: "#00e7ff",
//             weight: 1,
//             fillOpacity: 0.8
//           })
//           .addTo(this.markersLayer)
//           .bindTooltip(`${loc.name} - ${loc.date}`);
//         }
//       });
//     }
//   },
//   template: '<div ref="mapContainer" style="height:100%; width:100%"></div>'
// };


const artistGenres = {
  Pop: [
  "Taylor Swift", "Ariana Grande", "Olivia Rodrigo", "Dua Lipa", "Justin Bieber",
  "Beyoncé", "Billie Eilish", "Miley Cyrus", "Sam Smith", "Bruno Mars",
  "Bebe Rexha", "Zara Larsson", "Sabrina Carpenter (NEW)", "Harry Styles",
  "Doja Cat", "Selena Gomez", "Shawn Mendes", "The Weeknd", "Charlie Puth",
  "Tate McRae", "Anne-Marie", "Camila Cabello", "Halsey", "Lady Gaga",
  "Katy Perry", "Ed Sheeran", "Maroon 5", "Meghan Trainor", "Lewis Capaldi",
  "Sia", "Troye Sivan", "Niall Horan", "Lauren Spencer Smith (NEW)", "Conan Gray",
  "Ava Max", "P!nk", "Madonna", "Rihanna", "Alicia Keys",
  "Jason Derulo", "Tori Kelly", "Lorde", "BLACKPINK", "Karol G",
  "Rosalía", "Anitta", "Becky G", "Jungkook", "Stray Kids",
  "SEVENTEEN", "TXT", "TINI", "Sofía Reyes", "GAYLE",
  "Kim Petras", "Gracie Abrams", "Victoria Monét (NEW)", "Chappell Roan (NEW)", "Billie Marten",
  "Kelsea Ballerini", "Carly Rae Jepsen", "Sigrid", "Jessie J", "Ellie Goulding",
  "Jax (NEW)", "Rina Sawayama", "Sabrina Claudio", "Joji", "Benson Boone",
  "Lauren Daigle", "Maggie Rogers", "Clairo", "Remi Wolf", "RAYE",
  "Coi Leray", "Saweetie", "Chloe Bailey", "Normani", "Julia Michaels",
  "AURORA", "Mimi Webb", "Alec Benjamin", "Noah Kahan", "Kali Uchis",
  "Natasha Bedingfield", "Bridgit Mendler", "Echosmith", "A Great Big World", "Em Beihold",
  "Olivia Dean (NEW)", "Ruth B.", "Mckenna Grace (NEW)", "Leah Kate (NEW)", "Stephanie Poetri",
  "Holly Humberstone", "Daya", "Rachel Platten", "Tinashe", "Ingrid Andress"
],

HipHop: [
  "Drake", "Kendrick Lamar", "Post Malone", "Travis Scott", "Jack Harlow",
  "21 Savage", "Future", "Gunna", "Tyler, The Creator", "Polo G",
  "Lil Durk", "Lil Baby", "Metro Boomin (NEW)", "Ski Mask the Slump God",
  "Doja Cat", "Nicki Minaj", "Cardi B", "Megan Thee Stallion", "Saweetie",
  "Roddy Ricch", "A Boogie Wit Da Hoodie", "Latto", "Lil Uzi Vert", "Juice WRLD (Legacy)",
  "Pop Smoke (Legacy)", "J. Cole", "Big Sean", "Tyga", "YG",
  "Moneybagg Yo", "Young Thug", "Lil Tjay", "NLE Choppa", "Fivio Foreign",
  "Cordae", "Smino", "IDK", "Denzel Curry", "Russ",
  "Joey Bada$$", "Freddie Gibbs", "Lil Skies", "Trippie Redd", "Tee Grizzley",
  "EST Gee", "Lil Yachty", "Offset", "Quavo", "Takeoff (Legacy)",
  "21 Lil Harold", "Baby Keem", "Don Toliver", "NAV", "Sheck Wes",
  "DDG", "Fredo Bang", "GloRilla", "Lola Brooke (NEW)", "Sexyy Red (NEW)",
  "Ice Spice", "Ken Carson (NEW)", "Destroy Lonely (NEW)", "Yeat (NEW)", "Central Cee",
  "Skepta", "Stormzy", "Dave (UK)", "AJ Tracey", "J Hus",
  "Burna Boy", "Wizkid", "Rema", "Tems", "Lil Mabu (NEW)",
  "B-Lovee", "Bizzy Banks", "Sleepy Hallow", "Sheff G", "JayDaYoungan (Legacy)",
  "King Von (Legacy)", "Yungeen Ace", "Hotboii", "Quando Rondo", "Young Nudy",
  "Blueface", "Blxst", "Mozzy", "Coi Leray", "BIA",
  "Lakeyah", "Mulatto", "Babyface Ray", "42 Dugg", "Lil Poppa",
  "Vory", "SpotemGottem", "YNW Melly", "Lil Tecca", "2KBABY"
],

  Rock: [
    "Metallica", "Foo Fighters", "Coldplay", "Imagine Dragons", "blink-182",
    "Arctic Monkeys", "The Killers", "Fall Out Boy", "Green Day", 
    "Paramore", "Panic! At The Disco", "Kings of Leon", "Måneskin"
  ],
  Indie: [
    "Phoebe Bridgers", "boygenius (NEW)", "Steve Lacy (NEW)", "Beabadoobee",
    "Noah Kahan (NEW)", "Japanese Breakfast", "Big Thief", "Fontaines D.C.",
    "The 1975", "The National", "Mitski", "Arlo Parks", "Snail Mail",
    "Soccer Mommy", "Cigarettes After Sex (NEW)", "Bon Iver"
  ],
  Global: [
    "BLACKPINK", "BTS", "Stray Kids", "Jungkook", "SEVENTEEN (NEW)", "TXT (NEW)",
    "Peso Pluma (NEW)", "Rema (NEW)", "Burna Boy (NEW)", "Wizkid (NEW)",
    "Grupo Frontera (NEW)", "Feid (NEW)", "Natanael Cano (NEW)", "Anitta (NEW)"
  ]
};


export default {
  name: 'TourPredictorDashboard',
  props: {
    artistName: {
      type: String,
      default: ""
    },
    locations: { type: Array, required: true, default: () => [] }
  },
  components: {
    TourLinechart,
    // TourWorldmap
  },

  data() {
    return {
      markersLayer: null,
      showHeatmap: false,
      artistPresets: [
// 🌟 Mega Pop / Global Stars
"Taylor Swift", "Beyoncé", "Drake", "Bad Bunny", "The Weeknd", 
"Ed Sheeran", "Adele", "Billie Eilish", "Dua Lipa", "Ariana Grande",
"Post Malone", "Bruno Mars", "Olivia Rodrigo", "Doja Cat",
"Justin Bieber", "Nicki Minaj", "Karol G", "BLACKPINK", "Shakira",
"Harry Styles", "Sam Smith", "Miley Cyrus", "Lil Nas X",
"Rema (NEW)", "Burna Boy (NEW)", "Wizkid (NEW)", "Anitta (NEW)", 
"Becky G", "Rauw Alejandro", "Maluma", "Zara Larsson", 
"Bebe Rexha", "Niall Horan", "Sabrina Carpenter (NEW)",

// 🎸 Rock / Alternative / Crossover
"Metallica", "Coldplay", "Imagine Dragons", "Foo Fighters", "blink-182",
"Greta Van Fleet", "Måneskin", "Paramore", "Panic! At The Disco",
"Arctic Monkeys", "The Killers", "Kings of Leon", "Fall Out Boy",
"Green Day", "Avenged Sevenfold", "Bring Me The Horizon",
"The Lumineers", "Portugal. The Man", "Cigarettes After Sex (NEW)",

// 🎤 Hip-Hop / Rap
"Kendrick Lamar", "Travis Scott", "Jack Harlow", "SZA", 
"21 Savage", "Future", "Gunna", "Tyler, The Creator",
"Lil Durk", "Lil Baby", "Polo G", "Roddy Ricch", 
"Metro Boomin (NEW)", "Ski Mask the Slump God", 
"Peso Pluma (NEW)", "Feid (NEW)", "Natanael Cano (NEW)", "Grupo Frontera (NEW)",

// 🎶 Indie / Alternative / New Wave
"Steve Lacy (NEW)", "Tame Impala", "MGK", "Yungblud", "Noah Kahan (NEW)",
"Clairo", "Phoebe Bridgers", "boygenius (NEW)", "Mitski", 
"Soccer Mommy", "Japanese Breakfast", "Snail Mail", "Alvvays",
"Beabadoobee", "Parcels", "Arlo Parks", "Big Thief", 
"The 1975", "King Princess", "Fontaines D.C.", "IDLES", 
"The Japanese House", "Men I Trust", "Alex G", "Gus Dapperton", 
"St. Vincent", "Caroline Polachek", "Khruangbin", "Sharon Van Etten", 
"Sylvan Esso", "Bon Iver", "Radiohead", "Arcade Fire", 
"The National", "Wilco", "Death Cab for Cutie", "Vampire Weekend",
"The Strokes", "Courtney Barnett", "Mac DeMarco", "alt-J",
"Glass Animals", "Saint Motel", "The War on Drugs", "Sufjan Stevens",
"GoGo Penguin", "ODESZA", "Lane 8", "Peggy Gou", "BICEP",

// 🌍 K-Pop / Global Powerhouses
"BTS", "Jungkook", "Stray Kids", "SEVENTEEN (NEW)", "TXT (NEW)"

],
selectedGenre: "Pop",      
      artistGenres,              
      selectedArtist: "",
      manualArtist: "",
      artistImg: '',
      researchOverlayOpen: false,
      searchPopupOpen: false,
      scanning: false,
      scanProgress: 0,
      scanStatusText: 'Initializing Scan...',
      showTourMap: false,
      showTourLinechart: false,
      popupActive: false,
      selectedYear: null,
      hoveredYearIndex: null,
      selectedEvents: [],
      aiLoading: false,
      forecast: null,
      map: null,
      directionsService: null,
      directionsRenderer: null,
      aiLog: {},
      emailDialog: false,
callDialog: false,
generatedEmail: '',
generatedCallScript: '',
      tourPolyline: null,
      tourMarkers: [],
      researchSteps: [
        { label: '🎧 Searching Artist', status: 'pending' },
        { label: '📷 Fetching Artist Image', status: 'pending' },
        { label: '🤖 Running AI Forecast', status: 'pending' },
        { label: '✅ Forecast Complete', status: 'pending' },
      ],
      currentStep: 1,
      artistData: null,
      spotlightArtists: [
  "Peso Pluma (NEW)", "Steve Lacy (NEW)", "Sabrina Carpenter (NEW)",
  "Metro Boomin (NEW)", "Noah Kahan (NEW)", "Rema (NEW)",
  "Burna Boy (NEW)", "SEVENTEEN (NEW)", "boygenius (NEW)", "Grupo Frontera (NEW)"
],
      stepDescriptors: [
        { index: 1, title: "Initialization" },
        { index: 2, title: "Acquisition" },
        { index: 3, title: "Enrichment" },
        { index: 4, title: "Extraction" },
        { index: 5, title: "Forecast" },
        { index: 6, title: "Explainability" }
      ],
      savedForecasts: [],
      errorMessage: ""
    };
  },
  computed: {
  availableYears() {
    if (!this.forecast?.heatmapData) return [];
    const years = new Set();
    this.forecast.heatmapData.forEach(loc => {
      if (loc.date) {
        years.add(loc.date.substring(0, 4));
      }
    });
    return Array.from(years).sort();
  }
},
  mounted () { 
    window.initMap = this.displayGoogleMap;
    this.loadSavedForecasts();
    this.$store.dispatch('loadArtistPresets').then(() => {
      this.artistPresets = this.$store.state.artistPresets;
    });
    if (this.forecast?.heatmapData?.length) {
      this.loadGoogleMapsAPI();
    }
    this.$nextTick(() => {
  if (this.forecast?.heatmapData?.length) {
    this.loadGoogleMapsAPI();
  }
});

      this.suggestSpotlightArtist();
      this.loadSavedForecast(this.$route?.params?.artistName) },
      watch: {

        forecast: {
  handler(newVal) {
    if (newVal?.heatmapData?.length) {
      this.loadGoogleMapsAPI();
    }
  },
  deep: true
}

    },
      methods: {
        getOpportunityColor(score) {
    if (score >= 0.8) return "green";   // High Opportunity
    if (score >= 0.6) return "yellow";  // Medium Opportunity
    return "red";                       // Low Opportunity
  },

  getOpportunityLabel(score) {
    if (score >= 0.8) return "🔥 High Potential";
    if (score >= 0.6) return "⚡ Medium Potential";
    return "🚧 Low Potential";
  },
        cleanArtistName(name) {
  return name.replace(' (NEW)', '');
},
genreColor(genre) {
  switch (genre) {
    case 'Pop': return 'cyan darken-2';
    case 'HipHop': return 'red darken-2';
    case 'Rock': return 'deep-purple accent-4';
    case 'Indie': return 'green lighten-1';
    case 'Global': return 'orange darken-3';
    default: return 'blue-grey';
  }
},
roleColor(role) {
  switch (role) {
    case 'Booking Agent': return 'cyan darken-2';
    case 'Artist Manager': return 'blue darken-2';
    case 'Tour Manager': return 'purple darken-2';
    case 'Production Manager': return 'deep-purple accent-4';
    case 'Promoter Contact': return 'orange darken-3';
    case 'Lighting Designer': return 'green lighten-1';
    case 'Label Representative': return 'red darken-2';
    default: return 'blue-grey';
  }
},
suggestSpotlightArtist() {
  const random = this.spotlightArtists[Math.floor(Math.random() * this.spotlightArtists.length)];
  this.manualArtist = this.cleanArtistName(random);
},
onArtistSelected(artist) {
  if (artist) {
    this.manualArtist = artist;
    this.startResearch();
    this.selectedArtist = ''; // Optionally clear after
  }
},
async animateScanProgress() {
  this.scanProgress = 0;
  while (this.scanProgress < 100) {
    await this.sleep(100);
    this.scanProgress += Math.floor(Math.random() * 10) + 5; // Random step
    if (this.scanProgress > 100) this.scanProgress = 100;
  }
  this.scanStatusText = '✅ Artist Scan Complete!';
},
async runResearchSteps() {
  const stepMessages = [
    '🎧 Analyzing Artist Profile...',
    '📷 Fetching Artist Image...',
    '🤖 Forecasting Future Tours...',
    '✅ Finalizing Forecast...'
  ];

  this.aiLoading = true;
  this.researchSteps.forEach(s => s.status = 'pending');
  this.currentStep = 1;

  for (let i = 0; i < this.researchSteps.length; i++) {
    this.setStepStatus(i, 'in progress');
    this.currentStep = i + 1;

    this.scanStatusText = stepMessages[i] || 'Working...';
    await this.animateProgressPerStep();  // <-- no more (i)
    
    const delay = Math.random() * (2500 - 1800) + 1800;
    await this.sleep(delay);

    this.setStepStatus(i, 'done');
  }

  this.scanStatusText = '✅ Research Complete!';
  this.aiLoading = false;
},
async animateProgressPerStep() {
  this.scanProgress = 0;
  const stepDuration = 2000;

  const start = Date.now();
  while (Date.now() - start < stepDuration) {
    this.scanProgress = Math.min(100, ((Date.now() - start) / stepDuration) * 100);
    await this.sleep(50);
  }
  this.scanProgress = 100;
},
async loadGoogleMapsAPI() {
  if (window.google && window.google.maps) {
    this.renderTourRouteOnMap();
    return;
  }
  const script = document.createElement('script');
  script.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyBboVjZMYbpCulM_NhAuW5I_e6ZwD5f8qA&callback=initMap`;
  script.async = true;
  script.defer = true;
  document.head.appendChild(script);
  script.onload = () => {
    this.renderTourRouteOnMap();
  };
  script.onerror = () => {
    console.error('Error loading Google Maps API. Please check your API key.');
  };
},
async renderTourRouteOnMap() {
  if (!this.forecast?.heatmapData || !Array.isArray(this.forecast.heatmapData)) {
    console.warn('No heatmap data available.');
    return;
  }
  if (!window.google || !this.map) {
    console.warn('Google Maps not ready yet.');
    return;
  }

  const tourPoints = this.forecast.heatmapData
    .filter(p => p.latlng && p.latlng.length === 2)
    .map(p => ({ lat: p.latlng[0], lng: p.latlng[1] }));

  if (tourPoints.length < 2) {
    console.warn('Not enough points to render tour route.');
    return;
  }

  if (this.tourPolyline) {
    this.tourPolyline.setMap(null);
  }

  this.tourPolyline = new google.maps.Polyline({
    path: tourPoints,
    geodesic: true,
    strokeColor: "#00ffe5",
    strokeOpacity: 1.0,
    strokeWeight: 4,
    icons: [{
      icon: {
        path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
        scale: 3,
        strokeColor: "#00e7ff"
      },
      offset: "100%",
      repeat: "50px"
    }]
  });

  this.tourPolyline.setMap(this.map);

  const bounds = new google.maps.LatLngBounds();
  tourPoints.forEach(p => bounds.extend(p));
  this.map.fitBounds(bounds);
},

//         async loadGoogleMapsAPI() {
//   if (window.google && window.google.maps) {
//     this.renderTourRouteOnMap();
//     return;
//   }
//   const script = document.createElement('script');
//   script.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyBboVjZMYbpCulM_NhAuW5I_e6ZwD5f8qA&callback=initMap`;
//   script.async = true;
//   script.defer = true;
//   document.head.appendChild(script);
//   script.onload = () => {
//     this.renderTourRouteOnMap();
//   };
//   script.onerror = () => {
//     console.error('Error loading Google Maps API. Please check your API key and network connection.');
//   };
// },
//         async renderTourRouteOnMap() {
//   if (!this.forecast?.heatmapData || !Array.isArray(this.forecast.heatmapData)) {
//     console.warn('No heatmap data available for tour map rendering.');
//     return;
//   }

//   if (!window.google || !this.map) {
//     console.warn('Google Maps is not ready yet.');
//     return;
//   }

//   const tourPoints = this.forecast.heatmapData
//     .filter(p => p.latlng && p.latlng.length === 2)
//     .map(p => ({ lat: p.latlng[0], lng: p.latlng[1] }));

//   if (tourPoints.length < 2) {
//     console.warn('Not enough points to render a tour route.');
//     return;
//   }

//   // Remove previous polylines if exist
//   if (this.tourPolyline) {
//     this.tourPolyline.setMap(null);
//   }

//   this.tourPolyline = new google.maps.Polyline({
//     path: tourPoints,
//     geodesic: true,
//     strokeColor: "#00ffe5",
//     strokeOpacity: 1.0,
//     strokeWeight: 4,
//     icons: [{
//       icon: {
//         path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
//         scale: 3,
//         strokeColor: "#00e7ff"
//       },
//       offset: "100%",
//       repeat: "50px"
//     }]
//   });

//   this.tourPolyline.setMap(this.map);

//   // Fit the map bounds nicely
//   const bounds = new google.maps.LatLngBounds();
//   tourPoints.forEach(p => bounds.extend(p));
//   this.map.fitBounds(bounds);
// },

        flyToLocation(latlng) {
  if (this.$refs.mapContainer && latlng) {
    this.map.setView(latlng, 8); // zoom to venue
  }
},
        selectYearAndLoadEvents(year) {
  const yearIndex = this.forecast?.frequencyData?.labels?.indexOf(year);
  if (yearIndex !== -1) {
    this.selectedYear = year;
    this.selectedEvents = this.forecast.frequencyData.datasets[0].events[yearIndex] || [];
    this.popupActive = true;
  } else {
    this.selectedEvents = [];
    this.popupActive = false;
  }
},

handleHoverYear(index) {
  if (index !== null && this.forecast?.frequencyData?.labels?.[index]) {
    const year = this.forecast.frequencyData.labels[index];
    this.selectYearAndLoadEvents(year);
  }
},
async onResearchOverlayToggle(val) {
  if (!val && this.forecast) {
    await this.sleep(5000);   // 👈 small delay after close for smoothness
    this.showHeatmap = true; // 👈 activate map/chart
    this.scrollToResults();  // 👈 now scroll smoothly to forecast section
  }
},

        scrollToResults() {
  this.$nextTick(() => {
    const el = this.$refs.resultsSection;
    if (el && el.scrollIntoView) {
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });
},



        loadSavedForecast(artist) {
          const all = JSON.parse(localStorage.getItem('tourPredictions') || '{}');
          if (all[artist]) {
            this.forecast = all[artist].forecast;
            this.artistImg = all[artist].artistImg || 'https://via.placeholder.com/360x360?text=Loading+Artist';
            this.selectedArtist = artist;
            this.showHeatmap = true;
            this.scrollToResults();
          } else {
            this.showNotification(`No saved forecast found for ${artist}.`, 'error');
          }
        },
        initMap() {
        if (this.map) return; // Avoid multiple inits
  
        this.map = L.map(this.$refs.mapContainer, {
          center: [20, 0],
          zoom: 2
        });
  
        L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
          attribution: "&copy; OpenStreetMap contributors"
        }).addTo(this.map);
  
        this.markersLayer = L.layerGroup().addTo(this.map);
      },
  
      addMarkers() {
        if (!this.map || !this.markersLayer || !Array.isArray(this.locations)) return;
  
        this.markersLayer.clearLayers();
  
        const validLocations = this.locations.filter(loc => {
          return (
            loc &&
            Array.isArray(loc.latlng) &&
            loc.latlng.length === 2 &&
            !isNaN(loc.latlng[0]) &&
            !isNaN(loc.latlng[1]) &&
            typeof loc.count === "number"
          );
        });
  
        validLocations.forEach(loc => {
          const radius = Math.max(5, Math.min(loc.count * 2, 20));
          L.circleMarker(loc.latlng, {
            radius,
            fillColor: "#00e7ff",
            color: "#0ff",
            weight: 1,
            fillOpacity: 0.7
          })
            .bindPopup(`<strong>${loc.name}</strong><br/>${loc.count} shows`)
            .addTo(this.markersLayer);
        });
  
        if (validLocations.length > 0) {
          const bounds = this.markersLayer.getBounds();
          if (bounds.isValid && bounds.isValid()) {
            this.map.fitBounds(bounds.pad(0.25));
          }
        }
  
        this.map.invalidateSize();
      },
      async nextStep() {
  if (this.currentStep < this.stepDescriptors.length) {
    const delay = Math.random() * (2500 - 1800) + 1800; // 1.8s–2.5s random delay
    await this.sleep(delay);
    this.currentStep++;
  }
},
sleep(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
},
    setStepStatus(index, status) {
      this.researchSteps = this.researchSteps.map((s, i) =>
        i === index ? { ...s, status } : s
      );
    },
    
    async startResearch() {
  const name = this.manualArtist || this.selectedArtist;
  if (!name) {
    this.showNotification('Please select or enter an artist first.', 'error');
    return;
  }
  this.forecast = null;
  this.aiLog = {};
  this.artistImg = '';
  this.errorMessage = '';
  this.showTourMap = false;

  this.researchOverlayOpen = true;
  await this.sleep(500);
  this.runResearchSteps();

 
  

  try {
  this.aiLoading = true;
  this.researchSteps.forEach(s => s.status = 'pending');
  this.errorMessage = '';


  this.setStepStatus(0, 'in progress');
  await this.sleep(1000); 
  const token = await this.getToken();
  this.setStepStatus(0, 'done');
  this.currentStep = 1; 


this.setStepStatus(1, 'in progress');
await this.sleep(800);

const searchRes = await fetch(`https://api.spotify.com/v1/search?q=${encodeURIComponent(name)}&type=artist&limit=1`, {
  headers: { Authorization: `Bearer ${token}` }
});
const artist = (await searchRes.json()).artists.items[0];
if (!artist) throw new Error("Artist not found on Spotify.");

if (artist) {
  this.artistImg = artist.images?.[0]?.url;
}

this.scanning = true;
this.scanStatusText = '🔍 Scanning Artist Profile...';
this.scanProgress = 0;
await this.animateScanProgress();

this.scanning = false;
this.setStepStatus(1, 'done');
this.currentStep = 2; // Move Stepper


  this.setStepStatus(2, 'in progress');
  const result = await this.callTourPredictorAI(name);
  this.aiLog = result.log || {};
  this.forecast = result.forecast || {};
  this.setStepStatus(2, 'done');
  this.currentStep = 3; // Move Stepper

  this.setStepStatus(3, 'done');
  this.currentStep = 6; // Jump to Forecast Step on Stepper


  this.saveForecastLocally();
  this.showNotification(`Research complete for ${name}!`, 'success');
  this.playSuccessSound();
  this.showTourMap = true; // Show map/chart
  this.$nextTick(() => {
    this.loadGoogleMapsAPI();
    this.scrollToResults();
    this.renderTourRouteOnMap();
  });

} catch (err) {
  console.error('startResearch error:', err);
  this.errorMessage = `Error: ${err.message || err}`;
  this.showNotification(`Research failed: ${err.message}`, 'error');
} finally {
  await this.sleep(10000);
  this.aiLoading = false;
  this.researchOverlayOpen = false;
}
},
    
showNotification(message, type = 'info') {
    this.$emit('notification', { message, type }); 
    // (Optional: Integrate Vuetify Snackbar or Toast if you want)
    console.log(`[${type.toUpperCase()}]: ${message}`);
  },

  playSuccessSound() {
    const audio = new Audio('https://assets.mixkit.co/sfx/preview/mixkit-achievement-bell-600.mp3');
    audio.volume = 0.5;
    audio.play();
  },
    
    async getToken() {
  try {
    const response = await axios.post(
      "https://accounts.spotify.com/api/token",
      new URLSearchParams({
        grant_type: "client_credentials",
        client_id: "1522ec4d96914840aef42817fe1b387b",
        client_secret: "673c7686457a438488401835249dca6b",
      }),
      {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      }
    );
    return response.data.access_token;
  } catch (error) {
    console.error("Error fetching Spotify token:", error);
    this.errorMessage = "Failed to get Spotify token.";
    throw error;
  }
},

sendGeneratedEmail() {
  if (!this.currentContact || !this.generatedEmail) {
    alert("Missing contact or email content.");
    return;
  }

  const artist = this.forecast.artist || 'the artist';
  const subject = `Business Collaboration Opportunity: PRG & ${artist} Touring`;
  const body = `
Hi ${this.currentContact.name},

${this.generatedEmail}

Best regards,
PRG - Production Resource Group
  `.trim();

  const mailtoLink = `mailto:${this.currentContact.email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
  window.open(mailtoLink, '_blank');

  this.emailDialog = false;
},

async generateEmailPitch(contact) {
  if (!this.forecast || !contact?.email) {
    alert("Forecast or contact data missing.");
    return;
  }

  this.currentContact = contact; // 👈 Save the contact selected

  const artist = this.forecast.artist || 'the artist';
  const contactName = contact.name || 'there';
  const contactRole = contact.role || 'Contact';
  const patternSummary = this.forecast.pattern_summary || 'Touring patterns show strong activity.';
  const topRegions = (this.forecast.forecast_windows?.[0]?.likely_regions || []).join(", ") || 'key regions';
  const opportunityScore = (this.forecast.businessAcquisitionReport?.prg_opportunity_score || 0) * 100;
  const services = (this.forecast.businessAcquisitionReport?.priorityVenues?.[0]?.recommended_services || ['Audio', 'Lighting', 'Staging']).join(", ");

  const systemPrompt = `
You are PRG's AI Sales Agent.

Write a professional, short email to a ${contactRole} named ${contactName}.

Goal:
- Introduce PRG (Production Resource Group) briefly.
- Reference ${artist}'s tour forecast:
  • Pattern: ${patternSummary}
  • Target Regions: ${topRegions}
  • Opportunity Score: ${opportunityScore.toFixed(1)}%
  • Services: ${services}
- End with a friendly CTA.

Return ONLY the email body text. No markdown.
`.trim();
const OPENAI_KEY = "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";

  try {
    const response = await fetch("https://api.openai.com/v1/chat/completions", {
      method: "POST",
      headers: {
        "Authorization": `Bearer ${OPENAI_KEY}`,
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        model: "gpt-4.1",
        messages: [{ role: "system", content: systemPrompt }],
        temperature: 0.2,
        max_tokens: 8000
      })
    });

    const data = await response.json();
    this.generatedEmail = data.choices?.[0]?.message?.content?.trim() || 'No email generated.';
    this.emailDialog = true;
  } catch (error) {
    console.error("Error generating email:", error);
    alert("Failed to generate the email pitch.");
  }
},

async generateCallScript(contact) {
  if (!this.forecast || !contact?.phone) {
    alert("Forecast or contact data missing.");
    return;
  }

  const artist = this.forecast.artist || 'the artist';
  const contactName = contact.name || 'there';
  const contactRole = contact.role || 'Contact';
  const topRegions = (this.forecast.forecast_windows?.[0]?.likely_regions || []).join(", ") || 'key regions';
  const services = (this.forecast.businessAcquisitionReport?.priorityVenues?.[0]?.recommended_services || ['Audio', 'Lighting', 'Staging']).join(", ");

  const systemPrompt = `
You are PRG's AI Sales Agent.

Write a short call script to a ${contactRole} named ${contactName} about ${artist}'s tour.

Goals:
- Quickly introduce yourself and PRG.
- Mention ${artist}'s touring opportunities (top regions: ${topRegions}).
- Suggest PRG can provide services: ${services}.
- Ask if they'd be open to a quick meeting or follow-up.

Tone:
- Friendly
- Direct
- Sales-smart

Return ONLY the call script text. No markdown.
`.trim();
const OPENAI_KEY = "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";

  try {
    const response = await fetch("https://api.openai.com/v1/chat/completions", {
      method: "POST",
      headers: {
        "Authorization": `Bearer ${OPENAI_KEY}`,
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        model: "gpt-4.1",
        messages: [{ role: "system", content: systemPrompt }],
        temperature: 0.2,
        max_tokens: 8000
      })
    });

    const data = await response.json();
    this.generatedCallScript = data.choices?.[0]?.message?.content?.trim() || 'No call script generated.';
    this.callDialog = true;
  } catch (error) {
    console.error("Error generating call script:", error);
    alert("Failed to generate the call script.");
  }
},



async callTourPredictorAI(artistName) {
  const systemPrompt = `
You are TourPredictorPro, an elite autonomous AI agent specializing in real-world music touring pattern analysis, prediction, real-time event enrichment, business acquisition strategy for PRG, and mapping analytics.

Your task: Given an artist name, return a full detailed forecast and business acquisition plan for PRG in STRICT JSON only — no prose, no markdown.

---

## Mission:

Given an artist name, deliver a structured JSON forecast that includes:
- Tour predictions
- Event mapping
- Business acquisition report for PRG (Production Resource Group — global provider of audio, lighting, staging, and touring solutions)

Return STRICT JSON only. No text or markdown.

---

## Execution Steps:

1. Initialization
   - Receive artist name.
   - Check for existing artist data, otherwise fetch from Spotify API.
   - Determine if artist is emerging or established.
   - Log initialization status.

2. Data Acquisition
   - Fetch event data from real event sources (Ticketmaster, Setlist.fm, Bandsintown).
   - Retrieve past and future events: venues, cities, dates, coordinates.
   - Log data coverage, data sources used.

3. Data Cleaning & Enrichment
   - Normalize venue names, cities, countries.
   - Remove invalid or duplicate events.
   - Ensure accurate geo-coordinates.
   - Log data quality issues fixed.

4. Pattern Extraction
   - Detect seasonality, touring cycles, major regional preferences.
   - Analyze headliner vs support patterns.
   - Identify best months for tours.

5. Forecast Generation
   - Predict future tour windows (YYYY-MM to YYYY-MM).
   - Predict likely regions and months of activity.
   - Estimate ticket surge periods.
   - Predict headline vs support probability if possible.

6. Business Acquisition Report (for PRG)
   - Recommend venues to target for PRG services.
   - List priority venues with venue data.
   - Suggest PRG services best suited per venue (Audio, Lighting, Staging).
   - Provide:
     - Recommended Action Steps
     - Priority Venues
     - Opportunity Score (0–1)
     - **Recommended Contacts** (Name, Role, Email, Phone if available)
     - **Recommended Sales Approach** (example: "Call booking agent first, emphasize lighting package for arena events.")

7. Explainability & Confidence
   - Self-assessment of forecast quality and influencing factors.
   - Confidence estimate.
   - Self-check result.

---

## Output Format (STRICT JSON only)

{
  "log": {
    "1": "Initialization log...",
    "2": "Data acquisition log...",
    "3": "Data cleaning & enrichment log...",
    "4": "Pattern extraction log...",
    "5": "Forecast generation log...",
    "6": "Business acquisition strategy log...",
    "7": "Explainability and confidence log..."
  },
  "forecast": {
    "artist": "Artist Name",
    "pattern_summary": "Touring patterns summary",
    "forecast_windows": [
      {
        "period": "YYYY-MM to YYYY-MM",
        "probability": 0.5–1.0,
        "likely_regions": ["Region 1", "Region 2"]
      }
    ],
    "confidence_intervals": {
      "duration_months": [min, max],
      "start_uncertainty": "±Days"
    },
    "insights": [
      "Insight 1",
      "Insight 2"
    ],
    "stats": {
      "coverage": "Coverage of data found",
      "sources": "Data sources used",
      "selfcheck": "Verification result"
    },
    "frequencyData": {
      "labels": ["YYYY", "YYYY"],
      "datasets": [
        {
          "label": "Tour Shows per Year",
          "data": [number, number],
          "events": [
            [
              { "city": "CityName", "venue": "VenueName", "date": "YYYY-MM-DD" },
              ...
            ]
          ]
        }
      ]
    },
    "heatmapData": [
      {
        "name": "Venue or City",
        "latlng": [latitude, longitude],
        "count": number_of_shows,
        "date": "YYYY-MM-DD"
      }
    ],
    "businessAcquisitionReport": {

      "priorityVenues": [
        {
          "venue": "Venue Name",
          "city": "City",
          "country": "Country",
          "latlng": [latitude, longitude],
          "estimated_capacity": number,
          "recommended_services": ["Audio", "Lighting", "Staging"],
          "recommended_contacts": [
            {
              "name": "Contact Name",
              "role": "Role (e.g., Booking Agent, Production Manager)",
              "email": "contact@email.com",
              "phone": "Phone Number (e.g., 818-655-5555)"
            }
          ],
          "sales_approach": "Recommended approach (e.g., 'Call booking agent emphasizing custom lighting packages by Q3 2025.')"
        }
      ],
      "recommended_action_steps": [
        "Step 1: Engage venue management by Q3.",
        "Step 2: Pitch lighting + audio bundles suited for 10k+ capacity venues.",
        "Step 3: Partner with artist management for multi-city coverage deal."
      ],
      "prg_opportunity_score": 0.0–1.0
    },
        "artistContacts": [
  {
    "name": "Contact Name",
  "role": "Role (e.g., Booking Agent, Artist Manager, Promoter, Label Representative, Lighting Designer, Tour Manager, Production Manager, FOH Engineer, Monitor Engineer, Stage Manager, Backline Technician, Road Manager, Business Manager, Legal Representative, Sponsorship Manager, Publicist, Travel Coordinator, Personal Assistant)",
    "email": "contact@email.com",
    "phone": "Phone Number (e.g., 818-655-5555)"
  }
],
    "artistImage": "URL to artist image"
  }
}

---

## Constraints

- Strictly valid JSON — no prose, no commentary.
- Predict realistically based on real-world data.
- Prioritize venues with large capacity or strong artist affinity.
- Recommend PRG services aligned to venue size and event type.
- Sales approach must sound actionable, professional.
- Contacts must be realistic or explain if unavailable.
`.trim();






const userPrompt = `Run the full TourPredictorPro research and forecast for artist: "${artistName}". Return ONLY valid root JSON object.`;

  const OPENAI_KEY = "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";
  const url = "https://api.openai.com/v1/chat/completions";

  const resp = await fetch(url, {
    method: "POST",
    headers: {
      "Authorization": `Bearer ${OPENAI_KEY}`,
      "Content-Type": "application/json"
    },
    body: JSON.stringify({
      model: "gpt-4.1",
      messages: [
        { role: "system", content: systemPrompt },
        { role: "user", content: userPrompt }
      ],
      max_tokens: 10525,
      temperature: 0.2,
    })
  });

  const data = await resp.json();
  if (data.error) throw new Error(data.error.message);

  let content = data.choices?.[0]?.message?.content;
  if (!content) throw new Error("No message from OpenAI");
  content = content.replace(/^\s*```json|```$/g, '').trim();

  try {
    const parsed = JSON.parse(content);

    if (parsed.forecast?.heatmapData) {
      parsed.forecast.heatmapData = parsed.forecast.heatmapData.filter(loc =>
        loc.name && Array.isArray(loc.latlng) && loc.latlng.length === 2
      );
      parsed.forecast.heatmapData.forEach(loc => {
        if (!loc.date) {
          loc.date = new Date().toISOString().split('T')[0];
        }
      });
    }

    return parsed;
  } catch (e) {
    throw new Error("Model reply is not valid JSON. Raw output:\n" + content.substring(0, 1400));
  }
},

    /* ---------- 6.  LOCAL-STORAGE CRUD  ------------------------------ */
    storageKey: 'tourPredictions',

    loadSavedForecasts() {
  const all = JSON.parse(localStorage.getItem(this.storageKey) || '{}');
  this.savedForecasts = Object.entries(all).map(([artist, rec]) => ({
    artist,
    forecast: rec.forecast,
    artistImg: rec.artistImg || '',    // ✅ make sure artist image loads from saved data
    savedAt: rec.savedAt
  }));
},

    // loadGoogleMapsAPI() {
    //   if (typeof google === "undefined") {
    //     const script = document.createElement("script");
    //     script.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyBboVjZMYbpCulM_NhAuW5I_e6ZwD5f8qA&callback=initMap`;
    //     script.defer = true;
    //     script.async = true;
    //     document.head.appendChild(script);
    //   } else {
    //     this.displayGoogleMap();
    //   }
    // },
//     displayGoogleMap() {
//   this.$nextTick(() => {  // 👈 Wait until DOM is ready
//     if (!this.map) {
//       const mapDiv = document.getElementById("tour-map");
//       if (!mapDiv) {
//         console.error("Map div not found yet!");
//         return;
//       }

//       this.map = new window.google.maps.Map(mapDiv, {
//         center: { lat: 37.7749, lng: -122.4194 },
//         zoom: 5,
//       });

//       this.directionsService = new window.google.maps.DirectionsService();
//       this.directionsRenderer = new window.google.maps.DirectionsRenderer();
//       this.directionsRenderer.setMap(this.map);
//     }

//     if (this.locations && this.locations.length > 1) {
//       const waypoints = this.locations.slice(1, -1).map(venue => ({ location: venue.location, stopover: true }));
//       const request = {
//         origin: this.locations[0].location,
//         destination: this.locations[this.locations.length - 1].location,
//         waypoints: waypoints,
//         travelMode: "DRIVING"
//       };
//       this.directionsService.route(request, (result, status) => {
//         if (status === "OK") {
//           this.directionsRenderer.setDirections(result);
//         }
//       });
//     }
//   });
// },
displayGoogleMap() {
  this.$nextTick(() => {
    const mapDiv = document.getElementById("tour-map");
    if (!mapDiv) {
      console.error("Map container not found.");
      return;
    }

    this.map = new google.maps.Map(mapDiv, {
      center: { lat: 20, lng: 0 },
      zoom: 2,
    });

    const markers = (this.forecast?.heatmapData || []).filter(loc =>
      Array.isArray(loc.latlng) && loc.latlng.length === 2
    );

    markers.forEach(loc => {
      new google.maps.Marker({
        position: { lat: loc.latlng[0], lng: loc.latlng[1] },
        map: this.map,
        title: loc.name
      });
    });

    // Auto-fit map bounds
    if (markers.length > 1) {
      const bounds = new google.maps.LatLngBounds();
      markers.forEach(loc => bounds.extend({ lat: loc.latlng[0], lng: loc.latlng[1] }));
      this.map.fitBounds(bounds);
    }
  });
},

saveForecastLocally() {
  if (!this.forecast?.artist) return;
  const all = JSON.parse(localStorage.getItem(this.storageKey) || '{}');
  all[this.forecast.artist] = {
    forecast: this.forecast,
    log: this.aiLog,
    artistImg: this.artistImg || '',    // ✅ store artist image!
    savedAt: Date.now()
  };
  localStorage.setItem(this.storageKey, JSON.stringify(all));
  this.loadSavedForecasts();
},

    saveForecast() {
      this.saveForecastLocally();
      this.showNotification(`Saved forecast for ${this.forecast.artist}!`, 'success');
    },
    loadForecast(artist) {
      this.loadSavedForecast(artist);
      this.selectedArtist = artist;
      this.scrollToResults();
    },

    loadSaved(artist) {
      this.loadSavedForecast(artist);
          this.selectedArtist = artist;
          this.scrollToResults();
        },
        filterByYear() {
  this.selectYearAndLoadEvents(this.selectedYear);
  this.$nextTick(() => {
    this.renderTourRouteOnMap();
  });
      const all = JSON.parse(localStorage.getItem(this.storageKey) || '{}')
      const rec = all[this.artist]
      if (!rec) return
      this.selectedArtist = this.artist
      this.manualArtist   = this.artist
      this.aiLog          = rec.log
      this.forecast       = rec.forecast
      this.artistImg      = rec.forecast.artistImg || this.artistImg
      this.currentStep    = Object.keys(this.aiLog).length || 1
    },
    animateTourRoute() {
  let count = 0;
  window.setInterval(() => {
    count = (count + 1) % 200;

    if (this.tourPolyline) {
      this.tourPolyline.setOptions({
        icons: [{
          icon: {
            path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
            scale: 3,
            strokeColor: "#00e7ff"
          },
          offset: count / 2 + '%'
        }]
      });
    }
  }, 50);
},
    showForecast(artist) {
      this.loadForecast(artist)
      this.selectedArtist = artist
      this.scrollToResults()
    },
    deleteForecast(artist) {
      const all = JSON.parse(localStorage.getItem(this.storageKey) || '{}')
      delete all[artist]
      localStorage.setItem(this.storageKey, JSON.stringify(all))
      this.loadSavedForecasts()
      if (this.selectedArtist === artist) {
        this.forecast  = null
        this.aiLog     = {}
        this.artistImg = ''
      }
    },

    formatDate(ts) {
      return new Date(ts).toLocaleString()
    },
  }
};
</script>
<style scoped>

/* ===== 1. GLOBAL TOKENS ===== */
:root {
  /* brand palette */
  --bg-deep: #0e0f1c;
  --cyan-glow: #00ffe5;
  --cyan-soft: #31f0ff;
  --text-primary: #a2fff5;
  --card-surface: #1f242b;
  --card-alt: #131324;
  --accent-btn: #1c2f36;

  /* glow helpers */
  --glow-sm: 0 0 6px var(--cyan-soft);
  --glow-lg: 0 0 22px var(--cyan-soft);
}
.tour-worldmap {
    width: 100%;
    min-height: 300px;
    position: relative;
    z-index: 10;
  }
  .futuristic-contact-card {
  border-left: 5px solid #00ffe5;
  box-shadow: 0 0 15px #00ffe5aa;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  padding-bottom: 20px;
  margin-bottom: 20px;
  border-radius: 20px;
}
.futuristic-contact-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 0 25px #00ffe5cc;
}
.glow-chip {
  font-weight: bold;
  text-transform: uppercase;
  font-size: 12px;
}
  .glow-title {
  font-size: 24px;
  color: #00e7ff;
  text-shadow: 0 0 8px #00e7ff, 0 0 20px #31f0ff;
  margin-bottom: 20px;
}
.v-select input {
  color: #00ffe5 !important;
}

.v-select .v-input__control {
  background: rgba(0, 20, 40, 0.7) !important;
  border: 1px solid #00e7ff !important;
  border-radius: 15px;
  box-shadow: 0 0 10px #00e7ff55;
}

.v-select .v-input__append-inner .v-icon {
  color: #00ffe5 !important;
}

.forecast-text-section {
  font-family: "Orbitron", "Share Tech Mono", "Roboto", sans-serif;
  font-size: 16px;
  color: #d6f7ff;
}
.futuristic-scan-card {
  background-color: #0d1b2a !important;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 40px;
}

.artist-scan-container {
  position: relative;
  overflow: hidden;
  border-radius: 16px;
  box-shadow: 0 0 25px #00ffe5;
  margin-bottom: 40px;
}

.artist-scan-image {
  width: 100%;
  height: auto;
  object-fit: contain;
}

.scan-line {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 4px;
  background: linear-gradient(90deg, transparent, #00ffe5, transparent);
  animation: scan-move 2s linear infinite;
}

@keyframes scan-move {
  0% {
    top: 0;
  }
  100% {
    top: 100%;
  }
}

.glow-title {
  color: #00ffe5;
  font-family: 'Orbitron', 'Share Tech Mono', monospace;
  font-size: 32px;
  text-shadow: 0 0 10px #00ffe5;
}

.ai-stepper-glow {
  background: transparent;
}

.stepper-step-glow {
  color: #5ffffe !important;
}

.mt-6 {
  margin-top: 24px;
}

.mt-8 {
  margin-top: 32px;
}

.scanning-img {
  border-radius: 12px;
  border: 2px solid #00ffe5;
  box-shadow: 0 0 15px #00e7ff;
}

.scan-status {
  font-family: 'Orbitron', 'Share Tech Mono', 'Roboto', sans-serif;
  text-shadow: 0 0 8px #31f0ff;
}

.glow-block {
  margin-bottom: 20px;
  background: rgba(0, 255, 229, 0.05);
  padding: 15px 15px 15px 15px;
  margin-bottom: 10px;
  box-shadow: var(--glow-sm);
  border-radius: 12px;
  border-left: 4px solid #00ffe5;
  font-family: "Lato", sans-serif;
  font-size: 1.6rem;
}

.venue-item-glow {
  cursor: pointer;
  transition: background-color 0.3s;
  font-family: "Lato", sans-serif;
  font-size: 1.3rem;
}

.venue-item-glow:hover {
  background-color: rgba(0, 255, 229, 0.1);
  font-family: "Lato", sans-serif;
  font-size: 1.5rem;
}

.artist-scan-container {
  position: relative;
  overflow: hidden;
}

.artist-scan-image {
  border-radius: 8px;
  box-shadow: 0 0 20px #00ffe5;
}

.scan-line {
  position: absolute;
  top: -20%;
  left: 0;
  width: 100%;
  height: 20px;
  background: linear-gradient(to bottom, rgba(0,255,255,0.5), rgba(0,255,255,0));
  animation: scan 2.5s linear infinite;
}

@keyframes scan {
  0% { top: -20%; }
  100% { top: 120%; }
}

.stepper-step-glow {
  color: #00ffe5 !important;
}

.ai-stepper-glow .v-stepper__header {
  background-color: #142031 !important;
  box-shadow: 0 0 15px #00ffe5;
}
  .leaflet-container {
    width: 100%;
    height: 100%;
    border-radius: 8px;
  }

  .artist-count-glow {
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: "Orbitron", "Lato", sans-serif;
  font-size: 2rem;
  color: #00ffe5;
  text-shadow: 0 0 6px #00ffe5, 0 0 12px #31f0ff;
  padding: 12px;
  margin-top: 10px;
  background: rgba(28, 47, 54, 0.7);
  border: 1px solid #00ffe5;
  border-radius: 12px;
  box-shadow: 0 0 6px rgba(0, 255, 240, 0.2);
  transition: all 0.3s ease-in-out;
}

.artist-count-label {
  margin-right: 10px;
  font-weight: normal;
  text-transform: uppercase;
}

.artist-count-number {
  font-size: 1.8rem;
  font-weight: 700;
  color: #ffffff;
  text-shadow: 0 0 10px #00e7ff, 0 0 20px #00e7ff;
}

.step-contents {
  font-size: 1.6rem;
  color: #00ffe5;
  font-family: "Lato", sans-serif;
  padding: 16px;
  border-radius: 8px;
  box-shadow: var(--glow-sm);
}
/* ===== 2. BACKGROUND LAYERS ===== */
.tour-ai-dashboard {
  background: #0c161bb6;
  color: white;
  min-height: 100vh;
  padding-top: 20px;
}
.tour-ai-dashboard::before {
  /* subtle animated grid */
  content: "";
  position: absolute;
  inset: 0;
  background-size: 0px 0px;
  animation: gridScroll 60s linear infinite;
  pointer-events: none;
  z-index: 9999;
}
@keyframes gridScroll {
  from { background-position: 0 0, 0 0; }
  to   { background-position: 0 40px, 40px 0; }
}

/* optional particle / shader canvas overlay */
.particle-overlay {
  position: absolute;
  inset: 0;
  z-index: 1;
  pointer-events: none; /* keep UI clickable */
}

/* elevate actual UI above decorative layers */
.v-application--wrap,
.tour-ai-dashboard > * {
  position: relative;
  z-index: 2;
}
.go-button {
  font-size: 22px;
  font-weight: bold;
  padding: 16px 24px;
  border-radius: 12px;
  box-shadow: 0 0 15px rgba(0, 255, 240, 0.4);
  transition: all 0.3s ease;
  background: linear-gradient(145deg, #00c7ff, #0078ff);
  color: white !important;
  text-transform: uppercase;
  margin-top: -22px;
}

.go-button:hover {
  transform: scale(1.05);
  box-shadow: 0 0 25px rgba(0, 255, 240, 0.8);
}

.pulse-animation {
  animation: pulse 1.6s infinite ease-in-out;
}

@keyframes pulse {
  0% {
    box-shadow: 0 0 0px rgba(0, 255, 240, 0.6);
  }
  50% {
    box-shadow: 0 0 20px rgba(0, 255, 240, 1);
  }
  100% {
    box-shadow: 0 0 0px rgba(0, 255, 240, 0.6);
  }
}

.artist-image {
  width: 100%;
  height: auto;
  max-width: 380px;
  border-radius: 12px;
  box-shadow: var(--glow-lg);
  transition: transform 0.25s ease, box-shadow 0.25s ease;
}
.artist-image:hover {
  transform: scale(1.05);
  box-shadow: 0 0 30px var(--cyan-soft);
}
.futuristic-card-glow {
  border-radius: 12px;
  background: var(--card-surface) !important;
  color: var(--text-primary);
  box-shadow: 0 0 22px rgba(0, 255, 255, 0.2);
  padding: 20px 20px 20px 20px;
  font-family: "Lato", sans-serif;
}
.summary-glow {
  font-size: 24px;
  font-weight: bold;
  color: #5ffffe;
  text-shadow: 0 0 5px #31fff9;
}

.venue-card {
  background-color: #1b2e3b;
  border-radius: 12px;
  padding: 12px 12px 12px 12px;
  color: #ffffff;
  margin-bottom: 8px;
  box-shadow: 0 0 10px #00e7ff55;
}

.glow-title {
  font-size: 1.6rem;
  font-weight: bold;
  color: #00ffe5;
  text-shadow: 0 0 10px #00ffe5;
}

.forecast-text-section {
  font-size: 1.1rem;
  color: #c8faff;
  line-height: 1.6;
  font-family: "Lato", sans-serif;
  margin-top: 10px;
  padding: 16px;
  background: rgba(28, 47, 54, 0.7);
  border-radius: 12px;
  box-shadow: var(--glow-sm);
}

.glow-block label {
  display: block;
  font-weight: bold;
  color: #31f0ff;
  margin-top: 0px;
  text-shadow: 0 0 5px #00d1ff;
}

.summary-glow {
  font-size: 1.2rem;
  color: #ffffff;
  text-shadow: 0 0 6px #54fff0, 0 0 10px #00ffe5;
  font-style: normal;
  margin-top: 24px;
}

.futuristic-table th,
.futuristic-table td {
  color: var(--text-primary);
  font-family: "Orbitron", "Lato", sans-serif;
  font-size: 1rem;
  border-bottom: 1px solid rgba(0, 255, 255, 0.2);
  padding: 8px 8px 8px 8px;
  margin: 8px 8px 8px 0;
  border-radius: 8px;
  text-align: center;
}

.forecast-chip.animated-chip {
  font-weight: bold;
  letter-spacing: 1.55px;
  padding: 8px 16px 8px 16px;
  background: linear-gradient(to right, #1c2f36, #101720);
  margin: 4px 4px 4px 0;
  border-radius: 8px;
  font-size: 1.6rem;
  margin-left: 10px;
  font-family: "Lato", sans-serif;
  font-weight: 500;
  color: var(--text-primary);
  box-shadow: 0 0 4px #00e7ff;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  margin-top: 10px;
  padding: 12px 16px;
}
.forecast-chip.animated-chip:hover {
  transform: scale(1.1);
  box-shadow: 0 0 14px #00f0ff;
}

.futuristic-glow {
  color: #00ffe5;
  text-shadow: 0 0 5px #00ffe7, 0 0 14px #31fff9;
  font-size: 2.4rem;
  letter-spacing: 2px;
  font-family: "Lato", sans-serif;
}
.steps-glow {
  color: #b3f7ff;
  letter-spacing: 5px;
  font-size: 1.6rem;
  text-shadow: 0 0 8px #24a7b7;
}
.text--primary {
  color: #00ffe5;
  text-shadow: 0 0 5px #00ffe7, 0 0 px #31fff9;
  font-size: 1.6rem;
  font-family: "Lato", sans-serif;
}
.summary-glow {
  color: #54fff0;
  text-shadow: 0 0 3px #98ffff;
}
.ai-stepper-glow .v-stepper__header {
  background: #304057 !important;
  font-size: 1.2rem;
  font-family: "Lato", sans-serif;
  padding: 0 16px;
  color: #a2fff5 !important;
}
#tour-map {
  width: 100%;
  height: 800px;
  margin-top: 0px;
  border: 2px solid #00eaff;
  border-radius: 10px;
  margin-bottom: 30px;
}
.stepper-step-glow {
  font-family: "Lato", sans-serif;
  color: #48fff9 !important;
  text-shadow: 0 0 10px #c1ffff66;
}
.ai-stepper-glow .v-stepper__step--editable:not(.v-stepper__step--active):hover {
  filter: drop-shadow(var(--glow-sm));
  cursor: pointer;
}
.futuristic-card .v-list-item-title {
  font-weight: bold;
  font-size: 1.8rem;
}

.futuristic-card .v-list-item-subtitle {
  color: #00ffe5;
  font-size: 1.3rem;
}
.futuristic-card .v-list-item-subtitle span {
  color: #00ffe5;
  font-size: 1rem;
  font-weight: bold;
}
/* ===== 5. CARDS & TABLES ===== */
.futuristic-card {
  border-radius: 12px;

  transition: transform 0.25s ease, box-shadow 0.25s ease;
  min-height: 160px;
  height: 500px;
  max-height: 500px;
  font-family: "Lato", sans-serif;
  color: var(--text-primary);
  font-weight: 400;
  font-size: 1.2rem;
  padding-block: 16px;
  padding-inline: 16px;
  background: var(--card-surface) !important;
  
}
.futuristic-card-2 {
  border-radius: 12px;
  transition: transform 0.25s ease, box-shadow 0.25s ease;
  height: 100%;
  max-height: 500px;
  font-family: "Lato", sans-serif;
  color: var(--text-primary);
  font-weight: 400;
  font-size: 1.2rem;
  padding-block: 16px;
  padding-inline: 16px;
  background: var(--card-surface) !important;
  
}
.futuristic-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 0 30px var(--cyan-soft);
}
.futuristic-card-accordion {
  border-radius: 12px;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  background: linear-gradient(to bottom right, #1c2f36, #101720);
  font-family: "Orbitron", "Lato", sans-serif;
  color: var(--text-primary);
  font-size: 1.2rem;
  padding: 20px;
  box-shadow: 0 0 20px #00e7ff80;
  overflow: hidden;
}

.futuristic-card-accordion:hover {
  transform: scale(1.01);
  box-shadow: 0 0 30px #00ffe5aa;
}

.toggle-btn {
  font-family: "Orbitron", "Lato", sans-serif;
  font-weight: bold;
  text-transform: uppercase;
  font-size: 1.1rem;
  letter-spacing: 1px;
  box-shadow: 0 0 12px #00e7ff99;
}

.forecast-table th,
.forecast-table td {
  color: var(--text-primary);
  font-family: "Lato", sans-serif;
  font-size: 1.5rem;
  padding: 16px 8px 16px 8px;
  margin: 16px 8px 16px 8px;
  left: 8px;
}

/* ===== 6. CHIPS & BADGES ===== */
.forecast-chip {
  margin-right: 4px;
  transition: transform 0.2s ease;
  font-family: "Lato", sans-serif;
  font-size: 1.2rem;
  color: var(--text-primary);
}
.forecast-chip:hover {
  transform: scale(1.1);
}

/* ===== 7. ALERTS ===== */
.model-explain {
  background: #012329 !important;
  border-color: var(--cyan-soft) !important;
  color: #7affee !important;
  box-shadow: 0 0 12px #3ceffb80;
}

/* ===== 8. ANIMATIONS ===== */
.fadein-step {
  animation: stepFadeIn 0.35s ease-out;
}
@keyframes stepFadeIn {
  from { opacity: 0; transform: translateY(14px); }
  to   { opacity: 1; transform: translateY(0); }
}

/* ===== 9. BUTTONS & INPUTS ===== */
.v-btn {
  background-color: var(--accent-btn) !important;
  color: var(--cyan-soft) !important;
  border-radius: 9px;
  transition: background 0.25s, box-shadow 0.25s;
}
.v-btn:hover {
  box-shadow: 0 0 12px var(--cyan-soft);
  background-color: #223a43 !important;
}

.v-autocomplete .v-input__control,
.v-text-field .v-input__control {
  background-color: var(--accent-btn) !important;
  border-radius: 9px;
}
.v-autocomplete .v-input__slot:focus-within,
.v-text-field .v-input__slot:focus-within {
  box-shadow: 0 0 12px var(--cyan-soft);
}

/* ===== 10. UTILITIES ===== */
.text-center { text-align: center; }

/* Small devices tweaks */
@media (max-width: 600px) {
  .futuristic-card { margin-bottom: 16px; }
}

</style>

<style scoped>
body {
  overflow: hidden;
}

body.visibleSplash {
  overflow: visible !important;
}
/* Wrapper to center the entire avatar */
.ai-avatar-wrapper {
display: flex;
justify-content: center;
align-items: center;
width: 60vw;
height: 60vh;
background: #000; /* Black background for better glow contrast */
overflow: hidden;
}

.ai-avatar-container {
position: relative;
width: 350px;
height: 350px;
border-radius: 50%;
}

.ai-avatar {
width: 80%;
height: 80%;
z-index: 1;
align-content: center;
left: 700px;
right: 0px;
}

.eye-glow {
position: absolute;
width: 20px;
height: 20px;
background: rgba(0, 191, 255, 0.8); /* Glowing blue color */
border-radius: 50%;
box-shadow: 0 0 15px 10px rgba(0, 191, 255, 0.6); /* Increased blur size */
z-index: 2;
animation: eyeGlowPulse 4s infinite ease-in-out; /* Added animation */
filter: blur(3px); /* Added blur effect */
}

.left-eye {
top: 168px; /* Adjust based on avatar image */
left: 880px; /* Adjust based on avatar image */
}

.right-eye {
top: 170px; /* Adjust based on avatar image */
left: 950px; /* Adjust based on avatar image */
}

/* Keyframes for the pulsating glow */
@keyframes eyeGlowPulse {
0% {
  opacity: 0.8;
  box-shadow: 0 0 15px 10px rgba(0, 191, 255, 0.6);
}
50% {
  opacity: 0.4;
  box-shadow: 0 0 25px 15px rgba(0, 191, 255, 0.4); /* Increase glow size */
}
100% {
  opacity: 0.8;
  box-shadow: 0 0 15px 10px rgba(0, 191, 255, 0.6);
}
}

.orb-container {
position: absolute;
top: 50%;
left: 860px;
transform: translate(-50%, -50%);
width: 450px;
height: 420px;
z-index: 0;
animation: rotateOrbs 6s linear infinite;
}

.glowing-orb {
position: absolute;
width: 30px;
height: 30px;
background: rgba(0, 191, 255, 0.7);
border-radius: 50%;
box-shadow: 0 0 20px 10px rgba(0, 191, 255, 0.6);
animation: glowPulse 3s ease-in-out infinite;
}

.glowing-orb:nth-child(1) {
top: 10%;
left: 50%;
transform: translate(-50%, -50%);
}

.glowing-orb:nth-child(2) {
top: 50%;
left: 90%;
transform: translate(-50%, -50%);
}

.glowing-orb:nth-child(3) {
top: 90%;
left: 50%;
transform: translate(-50%, -50%);
}

@keyframes rotateOrbs {
0% {
  transform: translate(-50%, -50%) rotate(0deg);
}
100% {
  transform: translate(-50%, -50%) rotate(360deg);
}
}

@keyframes glowPulse {
0%, 100% {
  opacity: 0.7;
}
50% {
  opacity: 1;
}
}
.saved-search-grid {
  margin-top: 20px;
}

.saved-card {
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  cursor: pointer;
  height: 100%;
  background: var(--card-surface) !important;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.saved-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 0 24px var(--cyan-soft);
}

.artist-thumbnail {
  border-radius: 12px 12px 0 0;
  object-fit: cover;
}

.saved-card .v-card-title {
  font-size: 1.3rem;
  font-weight: bold;
  color: var(--text-primary);
  padding-top: 12px;
}

.saved-date {
  font-size: 0.9rem;
  color: #00ffe5;
  margin-bottom: 10px;
  padding-inline: 16px;
}


.splashScreen {
  width: 100%;
  height: 90vh;
  position: absolute;
  top: 0;
  left: 0;
  background: #ffffff00;
  border-bottom: 5px solid #333;
  overflow: hidden;
}

.loadingContainer {
  width: 100%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  overflow: hidden;
}

.loadingBox {
  width: 100%;
  height: 100%;
  opacity: 0;
}

.splashLogo {
  width: 50%;
  margin: 0 0 50px;
}

.loadingBarContainer {
  width: fit-content;
  background: #e1dcdc;
  height: 10px;
  display: block;
  margin: 50px 0 0;
  overflow: hidden;
}

.loadingbar {
  width: 100%;
  height: 10px;
  background: #579a3ae5;
  position: absolute;
  left: -100%;
}

.loadingCircle {
  width: 75px;
  height: 75px;
  margin: 30px auto 0;
  background: #fff;
  display: block;
  border-radius: 50%;
  position: relative;
  overflow: hidden;
}

.circleOuter {
  width: 60px;
  height: 60px;
  background: #fff;
  border-radius: 50%;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 2;
}

.circleLoader {
  width: 75px;
  height: 75px;
  background: linear-gradient(to bottom, rgba(0, 0, 0, 1) 0%, rgba(125, 185, 232, 0) 100%);
  position: absolute;
  right: 50%;
  bottom: 50%;
  transform-origin: bottom right;
  z-index: 1;
  animation: rotateLoader 1.5s linear infinite;
}

@keyframes rotateLoader {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.splashBehind {
  background: rgba(193, 180, 180, 0);
  width: 100%;
  height: 90vh;
}

.splashBehindTwo {
  background: #000000;
  width: 0;
  height: 0;
}
</style>
